import { AppOAuthStore } from "../AppOAuthSotarge";

export class Comentario{
    id_comentario : number;
    id_siniestro : number;
    comentario : string;
    id_registradopor : string;
    usuario_nombre : string;
    fecha_str : string;
    fecha_registro : Date;
    id : number;

    getFechaHora(yearStart? : boolean) : string{
        let f = new Date();
        let fecha = f.toLocaleDateString(yearStart ? "fr-CA" : "fr");
        let hora = f.toLocaleTimeString("fr").substring(0, 5);
        return fecha + ' ' + hora
    }

    constructor(public _comentario : string, storage : AppOAuthStore){
        this.id_comentario = 0;
        this.id_siniestro = 0;
        this.comentario = _comentario;
        this.usuario_nombre = storage.getItem("nombre_personal");
        this.id_registradopor = storage.getItem("id_usuario");
        this.fecha_str = this.getFechaHora();
        this.fecha_registro = new Date();
        this.id = 0;
    }
}